import { UseTicketResponse } from './useTicket.interface';

import { sendDatadogRumError } from 'utils/analytics/datadogRum';
import zendeskGateway from 'services/help-center/zendeskBackendGateway';

export default async function fetchTicket(ticketId: number): Promise<UseTicketResponse> {
    try {
        const response = await zendeskGateway.get<UseTicketResponse>(`/tickets/${ticketId}?include=last_audits`);
        return response.data;
    } catch (error) {
        sendDatadogRumError('fetchTicket', error, { source: 'fetchTicket', ticketId });
        throw new Error('Failed to fetch ticket data.');
    }
}
